// extracted by mini-css-extract-plugin
module.exports = {"HookSignature":"HookSignature-styles-module--HookSignature--1g3dh","count":"HookSignature-styles-module--count--3W_Vh"};